import { get, post, put, del } from '../apiService';
import type { QuizQuestion } from '../../types/content/quizQuestion';

export async function getQuizQuestionsByCourseId(courseId: string): Promise<QuizQuestion[]> {
  return get<QuizQuestion[]>(`/course/${courseId}/quiz-question`);
}

export async function createQuizQuestion(data: Partial<QuizQuestion>): Promise<QuizQuestion> {
  return post<QuizQuestion>('/quiz-question', data);
}

export async function updateQuizQuestion(id: string, data: QuizQuestion): Promise<QuizQuestion> {
  return put<QuizQuestion>(`/quiz-question/${id}`, data);
}

export async function deleteQuizQuestion(id: string): Promise<void> {
  return del<void>(`/quiz-question/${id}`);
}
